export const NORMALIZE = 'normalize'
export const CONVERT = 'convert'
